import DialogAlertAction from "components/DialogAlertAction/DialogAlertAction";
import { Paragraph } from "views/RefuerzoAcademico/components/AcadReinforceAttendance/styles";
import CustomButton from "components/CustomButton/CustomButton";
import { DIALOGS_ALERT_CHECKTIME } from "../TakeTeacherAttendancePanel/utils/constants";

const DialogCheckInTimeQuestion = ({
	dialog,
	serverTime,
	takeTeacherAttendance,
}) => {
	return (
		<DialogAlertAction
			minWidth={DIALOGS_ALERT_CHECKTIME.minWidth}
			show={dialog.value}
			toggleShow={dialog.toggle}
			title="Marcar entrada"
			contentComponent={
				<Paragraph>
					¿Estás seguro que deseas marcar tu entrada a las{" "}
					{serverTime}?
				</Paragraph>
			}
		>
			<CustomButton
				{...DIALOGS_ALERT_CHECKTIME.buttonProps.ok}
				onClick={() => {
					dialog.set(false);
					takeTeacherAttendance(true);
				}}
			/>
			<CustomButton
				{...DIALOGS_ALERT_CHECKTIME.buttonProps.cancel}
				onClick={() => dialog.set(false)}
			/>
		</DialogAlertAction>
	);
};

export default DialogCheckInTimeQuestion;
